<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="lg:col-6 col-12">
      <p-card>
        <div class="formgrid grid">
          <div class="field col-12">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="helpdeskTemplate.name"
              class="w-full"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div class="field-checkbox mb-0 col-12">
            <p-checkbox
              [(ngModel)]="helpdeskTemplate.disabled"
              [binary]="true"
              inputId="disabled"></p-checkbox>
            <label [for]="'disabled'">Неактивный</label>
          </div>
        </div>
      </p-card>

      <p-card styleClass="mt-3">
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium">Клиент</label>
            <crm-single-select
              [options]="clients"
              [(selectedItem)]="helpdeskTemplate.client"
              [styleClass]="errors?.client ? 'ng-invalid ng-dirty' : ''"
              [class]="errors?.client ? 'ng-invalid ng-dirty' : ''"
              [showClear]="true"
              (selectedItemChange)="changeClient($event)"
              appendTo="body"></crm-single-select>
            <small
              *ngIf="errors?.client"
              class="p-error">
              {{ errors.client | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Описание</label>
            <crm-template-subject-editor
              height="250px"
              [(value)]="helpdeskTemplate.description">
            </crm-template-subject-editor>
            <small
              *ngIf="errors?.description"
              class="p-error">
              {{ errors.description | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Время план</label>
            <p-inputNumber
              [(ngModel)]="helpdeskTemplate.plannedMin"
              [ngClass]="{ 'ng-invalid ng-dirty': errors?.plannedMin }"></p-inputNumber>
            <small
              *ngIf="errors?.plannedMin"
              class="p-error">
              {{ errors.plannedMin | join }}
            </small>
          </div>

          <div class="formgrid grid">
            <div class="field xl:col-6 col-12">
              <label class="font-medium">Действует до</label>
              <crm-datepicker
                [(value)]="helpdeskTemplate.activeUntil"
                (valueChange)="helpdeskTemplate.disabled = false"
                [inputStyleClass]="errors?.activeUntil ? 'ng-invalid ng-dirty' : ''"
                [minDate]="today"
                appendTo="body"
                styleClass="w-full"></crm-datepicker>
              <small
                *ngIf="errors?.activeUntil"
                class="p-error">
                {{ errors.activeUntil | join }}
              </small>
            </div>

            <div class="field xl:col-6 col-12">
              <label class="font-medium">Приоритет</label>
              <crm-single-select
                optionValue="name"
                [options]="priorities"
                [(selectedItem)]="helpdeskTemplate.priority"
                [styleClass]="errors?.priority ? 'ng-invalid ng-dirty' : ''"
                [class]="errors?.priority ? 'ng-invalid ng-dirty' : ''"
                [isTemplateCombined]="true"
                [filter]="false"
                appendTo="body">
                <ng-template
                  #itemTemplate
                  let-priority="item">
                  {{ priority?.value | helpdeskTaskPriorityName }}
                </ng-template>
              </crm-single-select>
              <small
                *ngIf="errors?.priority"
                class="p-error">
                {{ errors.priority | join }}
              </small>
            </div>

            <div class="field xl:col-6 col-12">
              <label class="font-medium">Эпик</label>
              <crm-master-milestone-single-select
                [(selectedMasterMilestone)]="helpdeskTemplate.masterMilestone"
                [isError]="$any(errors?.masterMilestone)"
                appendTo="body"></crm-master-milestone-single-select>
              <small
                *ngIf="errors?.masterMilestone"
                class="p-error">
                {{ errors.masterMilestone | join }}
              </small>
            </div>

            <div class="field xl:col-6 col-12">
              <label class="font-medium">Тип заявки</label>
              <crm-hd-task-type-single-select
                [customRequest]="true"
                [taskTypes]="taskTypes"
                [(selectedTaskType)]="helpdeskTemplate.taskType"
                [showClear]="true"
                [styleClass]="errors?.taskType ? 'ng-invalid ng-dirty' : ''"
                [class]="errors?.taskType ? 'ng-invalid ng-dirty' : ''"
                appendTo="body">
              </crm-hd-task-type-single-select>
              <small
                *ngIf="errors?.taskType"
                class="p-error">
                {{ errors.taskType | join }}
              </small>
            </div>

            <div class="field xl:col-6 col-12">
              <label class="font-medium">Бизнес единица</label>
              <crm-unit-single-select
                [(selectedUnit)]="helpdeskTemplate.unit"
                [isError]="$any(errors?.unit)"
                [showClear]="true"
                appendTo="body"></crm-unit-single-select>
              <small
                *ngIf="errors?.unit"
                class="p-error">
                {{ errors.unit | join }}
              </small>
            </div>
          </div>

          <div class="field">
            <h3 class="font-medium -mb-2">Планирование дедлайна</h3>
            <p-divider></p-divider>
            <crm-planning-deadline-form
              [planning]="helpdeskTemplate.deadline"
              appendTo="body"
              [errors]="$any(errors?.deadline)"></crm-planning-deadline-form>
          </div>
        </div>
      </p-card>

      <div class="mt-3">
        <crm-planning-periodicity-card
          [planning]="helpdeskTemplate.planning"
          [errors]="$any(errors?.planning)"
          appendTo="body"></crm-planning-periodicity-card>
      </div>
    </div>

    <div class="lg:col-6 col-12 flex gap-3 flex-column">
      <p-card header="Участники">
        <div class="field">
          <label class="font-medium required-field">Ответственный</label>
          <crm-user-single-select
            [(selectedUser)]="helpdeskTemplate.responsible"
            [isError]="$any(errors?.responsible)"
            appendTo="body"></crm-user-single-select>
          <small
            *ngIf="errors?.responsible"
            class="p-error">
            {{ errors.responsible | join }}
          </small>
        </div>

        <div class="field">
          <label class="font-medium">Внешний пользователь</label>
          <div class="flex align-items-center gap-1">
            <div class="flex-grow-1">
              <crm-external-user-single-select
                [customSearch]="true"
                [entities]="externalUsers"
                [(selectedEntity)]="helpdeskTemplate.externalUser"
                [isError]="$any(errors?.externalUser)"
                [disabled]="!helpdeskTemplate.client?.id"
                appendTo="body">
              </crm-external-user-single-select>
            </div>
            <crm-button
              *ngIf="helpdeskTemplate.client?.id && helpdeskTemplate.client?.contragents?.length"
              icon="pi pi-plus"
              styleClass="p-button-success frm-form-control-icon-btn"
              (onClick)="openFormCreateExternalUser()"></crm-button>
          </div>
          <small
            *ngIf="errors?.externalUser"
            class="p-error">
            {{ errors.externalUser | join }}
          </small>
        </div>

        <h3 class="font-medium -mb-2">Аудиторы</h3>
        <p-divider></p-divider>
        <div class="formgrid grid">
          <div class="field lg:col-6 col-12">
            <label class="font-medium">Пользователи</label>
            <crm-user-multi-select
              [(selectedUsers)]="helpdeskTemplate.userAuditors"
              [isError]="$any(errors?.userAuditors)"
              [customRequest]="true"
              [isFloatLabel]="false"
              appendTo="body"></crm-user-multi-select>
            <small
              *ngIf="errors?.userAuditors"
              class="p-error">
              {{ errors.userAuditors | join }}
            </small>
          </div>

          <div class="field lg:col-6 col-12">
            <label class="font-medium">Группы</label>
            <crm-user-group-multi-select
              [(selectedUserGroups)]="helpdeskTemplate.userGroupAuditors"
              [isFloatLabel]="false"
              [class]="errors?.userGroupAuditors ? 'ng-invalid ng-dirty' : ''"
              [styleClass]="errors?.userGroupAuditors ? 'ng-invalid ng-dirty' : ''"
              appendTo="body">
            </crm-user-group-multi-select>
            <p
              *ngIf="errors?.userGroupAuditors"
              class="p-error">
              {{ errors.userGroupAuditors | join }}
            </p>
          </div>
        </div>
      </p-card>

      <p-card
        *ngIf="accessService.finance.dealRights.canReadDeal"
        header="Сделка">
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium">Сделка</label>
            <crm-deal-auto-complete
              [(selectedDeal)]="helpdeskTemplate.deal"
              [isError]="$any(errors?.deal)"
              [showClear]="true"
              appendTo="body"></crm-deal-auto-complete>
            <small
              *ngIf="errors?.deal"
              class="p-error">
              {{ errors.deal | join }}
            </small>
          </div>
        </div>
      </p-card>

      <p-card
        *ngIf="accessService.project.projectRights.canReadProject"
        header="Задача">
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium">Задача</label>
            <crm-project-auto-complete
              [(selectedProject)]="helpdeskTemplate.project"
              [showClear]="true"
              [isError]="$any(errors?.project)"
              appendTo="body">
            </crm-project-auto-complete>
            <small
              *ngIf="errors?.project"
              class="p-error">
              {{ errors.project | join }}
            </small>
          </div>
        </div>
      </p-card>

      <crm-created-tasks-widget
        *ngIf="(form$ | async)?.isShowDelete && periodicity !== TemplateEntityPeriodicityEnum.NONE"
        [tasks]="createdTasks"
        [loading]="createdTasksLoading"
        (directToTasksList)="directToTasksList()"></crm-created-tasks-widget>
    </div>
  </div>

  <div class="grid mt-3">
    <div class="lg:col-6 col-12 flex flex-wrap justify-content-between">
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success"
        (onClick)="saveTemplate()"></crm-button>
      <crm-button
        *ngIf="(form$ | async)?.isShowDelete"
        label="Удалить"
        styleClass="p-button-danger p-button-text"
        (onClick)="deleteTemplate()"></crm-button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
